import InputFactory from "../../../../../components/InputFactory";
import NetSummary from "./NetSummary";
import dialog from "../../../../../components/Modal/dialog";
import { useState } from "react";
import { useEffect } from "react";
import FormField from "../FormField";

function Form({
  formData,
  handleSubmit,
  minDate,
  maxDate,
  schema,
  schemas,
  onChange,
  setFormData,
  tinNo,
  supplierPointerRef,
  bankPointerRef,
  categoryRef,
  dateField,
  supplierField,
  supplier,
  user,
  ...props
}) {
  const [_formData, _setFormData] = useState({});
  const [uploading, setUploading] = useState(0);

  useEffect(() => {
    _setFormData(formData);
  }, [formData]);

  return (
    <>
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-1">
        <div className="d-flex flex-column flex-md-row gap-2 py-2 align-content-stretch">
          <InputFactory
            type="Image"
            field="image"
            object={_formData}
            value={_formData?.image || ""}
            defaultValue={_formData?.image || ""}
            className="bg-white col-md-6 col-12"
            onChange={onChange}
            setUploading={setUploading}
            {...props}
          />

          <div className="d-flex flex-column gap-2 my-2">
            {dateField && (
              <FormField label="Date" required>
                <InputFactory
                  type="Date"
                  field="date"
                  required
                  min={minDate}
                  max={maxDate}
                  placeholder="Enter Date"
                  value={_formData?.date || ""}
                  defaultValue={_formData?.date || ""}
                  className="border border-1 border-dark-subtle bg-white"
                  onChange={onChange}
                  {...props}
                />
              </FormField>
            )}

            {supplierField && (
              <div className="d-flex gap-2">
                <FormField label="Supplier" required>
                  <InputFactory
                    type="Pointer"
                    target="suppliers"
                    schema={schema}
                    schemas={schemas}
                    field="supplier"
                    defaultValue={_formData?.supplier || ""}
                    includes={["all"]}
                    keys={["tinNo", "isVatable", "city"]}
                    required
                    resetRef={supplierPointerRef}
                    placeholder="Select Supplier"
                    className="border border-1 border-dark-subtle bg-white"
                    onChange={onChange}
                    where={{
                      $and: [{ creator: { id: user?.id } }, { isActive: true }],
                    }}
                  />
                </FormField>

                <FormField label="TIN">
                  <InputFactory
                    type="String"
                    target="suppliers"
                    disabled
                    placeholder="000-000-000"
                    value={tinNo}
                    className="border border-1 border-dark-subtle bg-light"
                    onChange={onChange}
                    {...props}
                  />
                </FormField>
              </div>
            )}

            <div className="d-flex gap-2">
              <FormField label="Bank" required className="flex-grow-1">
                <InputFactory
                  type="Pointer"
                  target="banks"
                  schema={schema}
                  schemas={schemas}
                  field="bank"
                  includes={["all"]}
                  required
                  keys={["balance"]}
                  resetRef={bankPointerRef}
                  placeholder="Select Bank"
                  object={_formData}
                  className="border border-1 border-dark-subtle bg-white"
                  onChange={onChange}
                  {...props}
                />
              </FormField>

              <FormField label="Category" required className="flex-grow-1">
                <InputFactory
                  type="Enum"
                  field="category"
                  options={["Capital Goods", "Services", "Others"]}
                  placeholder="Select category"
                  defaultValue={_formData?.category || ""}
                  resetRef={categoryRef}
                  className="border border-1 border-dark-subtle bg-white"
                  required
                  onChange={onChange}
                  {...props}
                />
              </FormField>
            </div>

            <div className="d-flex gap-2">
              <FormField
                // label={`Gross  ${
                //   _formData?.supplier?.isVatable || supplier?.isVatable
                //     ? "(VATable)"
                //     : ""
                // }`}
                label="Total Amount"
                sublabel="VAT-inclusive"
                required
              >
                <InputFactory
                  type="Currency"
                  field="gross"
                  required
                  placeholder="0.00"
                  // value={tinNo}
                  defaultValue={_formData?.gross || ""}
                  className="border border-1 border-dark-subtle bg-white w-100"
                  onChange={onChange}
                  {...props}
                />
              </FormField>
              {_formData?.supplier?.isVatable || supplier?.isVatable ? (
                <FormField label="Gross (VAT Exempt)">
                  <InputFactory
                    type="Currency"
                    field="vatExempt"
                    placeholder="0.00"
                    defaultValue={_formData?.vatExempt}
                    className="border border-1 border-dark-subtle bg-white w-100"
                    onChange={onChange}
                    {...props}
                  />
                </FormField>
              ) : (
                ""
              )}
            </div>

            {_formData?.supplier?.isVatable || supplier?.isVatable ? (
              <FormField label="Zero Rated">
                <InputFactory
                  type="Currency"
                  field="zeroRated"
                  placeholder="0.00"
                  defaultValue={_formData?.zeroRated}
                  className="border border-1 border-dark-subtle bg-white w-100"
                  onChange={onChange}
                  {...props}
                />
              </FormField>
            ) : (
              ""
            )}
          </div>
        </div>
        <NetSummary net={_formData?.net} vat={_formData?.vat} />
        <div className="d-flex gap-2">
          <button
            type="button"
            className="flex-fill btn btn-light fw-bold"
            onClick={() => dialog.close()}
            style={{ backgroundColor: "#D1D1D1" }}
          >
            Close
          </button>
          <button
            type="submit"
            disabled={uploading > 0}
            className="flex-fill btn btn-primary fw-bold"
          >
            {uploading > 0
              ? "Uploading..."
              : _formData.status === "draft"
                ? "Save"
                : "Update"}
          </button>
        </div>
      </form>
    </>
  );
}

export default Form;
